import { render } from "./BgMedia.vue?vue&type=template&id=a6984f7a"
import script from "./BgMedia.vue?vue&type=script&lang=js"
export * from "./BgMedia.vue?vue&type=script&lang=js"

import "./BgMedia.vue?vue&type=style&index=0&id=a6984f7a&lang=scss"

import exportComponent from "/var/www/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__